





































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseRepository from '@/core/HttpResources/BaseRepository';
import GenericAdd from '@/core/Generics/GenericAdd';
import LanguageLabel from  "@/models/language/LanguageLabel/languageLabel.model"

@Component
export default class LanguageLabelAdd extends GenericAdd<LanguageLabel> {
  constructor() {
    super();
    this.controller = 'LanguageLabel';
    this.model = new LanguageLabel();
  }

  saveAll(){
      this.model.languageGroupId = this.$route.params.languageGroupId as any;
      this.model.languageId = this.$route.params.languageId as any;
      return this.validate();
  }
}
